<template>
  <div class="panel-top mx-m20 mt-m20 pb-0" style="z-index:9;">
      <div class="header-panel">
          <div class="pl-10 mr-auto pointer" style="width: 200px; position: relative; top: -9px;">
            <FilterMultipleDropdown
                v-if="filterEnabled"
                :options="depotListData['list']"
                :defaultSelectAll="true"
                placeholder="All Depots"
                :selectAllOption="true"
                :selected="depotListData.selected"
                @updateOption="selectDepot"
            />
          </div>
          <div class="mr-auto pointer" style="width: 200px; position: relative; top: -9px;">
            <FilterMultipleDropdown
                v-if="filterEnabled"
                :options="transporterList.list"
                :defaultSelectAll="true"
                placeholder="All Transporters"
                :selectAllOption="true"
                :selected="transporterList.selected"
                @updateOption="selectTransporter"
            />
          </div>
          <div class="ml-auto" style="display: flex; align-items: center; gap: 8px;">
            <DatePicker
              v-model="dateRange"
              type="datetimerange"
              :clearable="false" size="small"
              prefix-icon="el-icon-date" s
              tart-placeholder="Start date"
              end-placeholder="End date"
              :default-time="['00:00:00', '23:59:59']"
              class="date-plain no-bg"
              :picker-options="validPickerOptions"
              @change="checkAndUpdate"
              @blur="checkAndClear">
            </DatePicker>

          </div>
      </div>
      <div style="overflow: hidden; width: 100%;">
        <div class="flex-center">
          <div class="d-flex" style="overflow: auto;">
            <div style="display: flex; align-items: center; max-width: 100%; width: auto; overflow: auto;">
              <div class="mb-15">
                <div class="d-flex" v-if="$hasPermission('view_exception') && !integrationEvent && !isCourierEvent">
                  <div class="panel-list">
                    <div class="list-title">
                      <span>{{ $t('INDENT_TOTAL') }}</span>
                    </div>
                    <DashboardCard className="no-bg" :listItems="totalItems" :countData="countData" />
                  </div>
                  <div class="panel-list ml-10">
                    <div class="list-title">
                      <span>{{ $t('EXCEPTION_INDENTS') }}</span>
                    </div>
                    <DashboardCard className="status-purple" :listItems="indentFilters" :countData="countData"
                      :selectedCategory="selectedCategory" @section-change="categoryChange" />
                  </div>
                  <div class="panel-list ml-10">
                    <div class="list-title">
                      <span>{{ $t('DELIVERY_EXCEPTION') }}</span>
                    </div>
                    <DashboardCard className="status-purple" :listItems="DeliveryItems" :countData="countData"
                      :selectedCategory="[selectedType]" @section-change="sectionChange" />
                  </div>
                </div>
                <div v-else-if="integrationEvent && (showOutboundTransactions || showInboundTransactions)"
                  class="panel-list ml-10">
                  <div class="panel-list">
                    <div class="list-title">
                      <span>{{ $t('INTEGRATION_SUCCESSFUL') }}</span>
                    </div>
                    <DashboardCard className="status-green" :listItems="successfulItems"
                      :countData="integrationEventCount" :selectedCategory="selectedCategory"
                      @section-change="sectionChange" />
                  </div>
                  <div class="panel-list ml-15" v-if="showOutboundTransactions">
                    <div class="list-title">
                      <span>{{ $t('INTEGRATION_TRANSACTIONS_OUTBOUND') }}</span>
                    </div>
                    <DashboardCard className="status-red" :listItems="integrationFilters"
                      :countData="integrationEventCount" :selectedCategory="selectedCategory"
                      @section-change="categoryChange" />
                  </div>
                  <div class="panel-list ml-15" v-if="showInboundTransactions">
                    <div class="list-title">
                      <span>{{ $t('INTEGRATION_TRANSACTIONS_INBOUND') }}</span>
                    </div>
                    <DashboardCard className="status-red" :listItems="integrationInboundFilters"
                      :countData="integrationEventCount" :selectedCategory="selectedCategory"
                      @section-change="categoryChange" />
                  </div>
                </div>
                <div v-else-if="!integrationEvent && isCourierEvent" class="panel-list ml-10">
                  <div class="panel-list">
                    <div class="list-title">
                      <span>{{ $t('COURIER_SUCCESSFUL') }}</span>
                    </div>
                    <DashboardCard className="status-green" :listItems="successfulCourierItems"
                      :countData="courierEventCount" :selectedCategory="selectedCategory"
                      @section-change="sectionChange" />
                  </div>
                  <div class="panel-list ml-15">
                    <div class="list-title">
                      <span>{{ $t('COURIER_TRANSACTIONS') }}</span>
                    </div>
                    <DashboardCard className="status-red" :listItems="courierFilters" :countData="courierEventCount"
                      :selectedCategory="selectedCategory" @section-change="categoryChange" />
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column">
              <div class="reload-list">
                <svgicon name="icon-fetch" width="10" height="10" @click="loadCounts" />
              </div>
            </div>
          </div>
          <div v-if= "isCourierDashboard" style="width: 340px;">
            <div  v-if="checkdaterange" class="text-red text-sm pb-20" >NOTE:
              Select date range for {{ extendedDateRange ? 45 : 7 }} days and select one category </div>
              <div class="text-center">
                <Button type="primary" :disabled="checkdaterange" @click="courierexport">Export</Button>
              </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import {
  EXCEPTION_TYPE,
  totalItems,
  DeliveryItems,
  indentFilters,
  allDates,
  IntegrationItem,
} from '@/constants/exception-data';
import {
  integrationFilters, integrationInboundFilters,
  successfulItems, INTEGRATION_TYPE,
  courierFilters, successfulCourierItems
} from '@/constants/integrations';
import DashboardCard from '@common/components/DashboardCard.vue';
import { interfaceEventType, mdm } from 'pando-constants'
import FilterMultipleDropdown from '@common/components/FilterMultipleDropdown';

export default {
  name: 'head-panel',
  props: {
    isLisLoadingCompleted: {
      type: Boolean,
      default: true,
    },
    integrationEvent: {
      type: Boolean,
      default: false,
    },
    isCourierEvent: {
      type: Boolean,
      default: false,
    },
    filterEnabled:{
      type:Boolean,
      default: false
    },
    depotListData: {
      type: Object ,
    },
    transporterList: {
      type: Object ,
    }
  },
  components: {
    DashboardCard,
    FilterMultipleDropdown
  },
  data() {
    return {
      dateRange: [],
      selectedType: EXCEPTION_TYPE.DELIVERIES,
      selectedCategory: [],
      selectedCloumn: '',
      totalItems,
      DeliveryItems,
      IntegrationItem,
      indentFilters,
      allDates,
      selectedDates: [],
      countData: {
        totalIndents: 0,
        deliveries: 0,
        direct_dispatch: 0,
        optima: 0,
        totalDeliveries: 0,
        integrationEvents: 0,
      },
      integrationEventCount: {
        successfulEntity: 0,
        modified_picklist_posting: 0,
        zpod_posting: 0,

        freight_provision_posting: 0,
        freight_invoice_posting: 0,
        direct_dispatch: 0,
        material_invoice: 0,
        epod: 0,
        bulk_indent: 0,
        shipment_status: 0,
        discard_optima: 0,
        delivery_picklist_optima: 0,
      },
      courierEventCount: {
        all_courier_successfull: 0,
        lr_booking: 0,
        lr_cancellation: 0,
        lr_update: 0,
        lr_tracking: 0,
      },
      dropDownActive: false,
      startDate: null,
      endDate: null,
      integrationFilters,
      integrationInboundFilters,
      successfulItems,
      courierFilters,
      successfulCourierItems,
      selectedDepotIds: [],
      selectedTransporterIds: [],
    };
  },
  async created() {
    if (this.extendedDateRange) {
      this.endDate = moment(new Date()).endOf('day').toDate();
      this.dateRange[0] = moment(new Date()).subtract(44, 'days').startOf('day').toDate();
      this.dateRange[1] = moment(new Date()).endOf('day').toDate();
    } else {
      this.endDate = moment(new Date()).add(1, 'days').toDate().setHours(23, 59, 59, 999);
      this.dateRange[0] = moment(new Date()).subtract(this.isCourierEvent ? 30 : 5, 'days').startOf('day').toDate();
      this.dateRange[1] = moment(new Date()).add(1, 'days').endOf('day').toDate();
    }
    if (this.integrationEvent) {
      this.selectedCategory = [this.successfulItems[0].key];
    }
    else if (this.isCourierEvent) {
      this.selectedCategory = [this.successfulCourierItems[0].key];
    }
    await this.loadCounts();
  },
  computed: {
    showInboundTransactions() {
      return this.$hasFeature('inbound_integrations_transaction');
    },
    showOutboundTransactions() {
      return this.$hasFeature('outbound_integrations_transaction');
    },
    extendedDateRange() {
      return this.$hasFeature('extended_integration_date_range');
    },
    validPickerOptions() {
      return {
        disabledDate: function (time) {
          if (this.extendedDateRange) {
            const today = moment().endOf('day').toDate();
            const maxPast = moment().subtract(6, 'months').startOf('day').toDate();
            if (time > today || time < maxPast) return true;
            if (this.startDate) {
              const rangeStart = moment(this.startDate).subtract(45, 'days').startOf('day').toDate();
              const rangeEnd = moment(this.startDate).add(45, 'days').endOf('day').toDate();
              return time < rangeStart || time > rangeEnd || time > today;
            }
            return false;
          }
          return (
            (this.endDate) ? (time > this.endDate) || (time < moment(this.endDate).subtract(this.isCourierEvent ? 31 : 7, 'days').toDate()) : false
          );
        }.bind(this),
        onPick: function (date) {
          this.setStartDate(date.minDate);
        }.bind(this),
      };
    },
    getDateString() {
      let dateString = '';
      const yesterday = moment().add(-1, 'days').format('Do MMM');
      const today = moment().format('Do MMM');
      const tomorrow = moment().add(1, 'days').format('Do MMM');
      this.selectedDates.forEach((dateIdx) => {
        if (dateIdx === 0) {
          dateString += `${moment().add(-1, 'days').format('Do MMM')} `;
        }
        if (dateIdx === 1) {
          dateString += `${moment().format('Do MMM')} `;
        }
        if (dateIdx === 2) {
          dateString += `${moment().add(1, 'days').format('Do MMM')} `;
        }
      });
      if (dateString === '') {
        dateString = `${yesterday},${today},${tomorrow}`;
      }
      return dateString;
    },
    isCourierDashboard(){
      return this.$route.name === 'courier'
    },
    checkdaterange(){
      const differenceInDays = moment(this.dateRange[1]).diff(moment(this.dateRange[0]), 'days');
      const maxExportDays = this.extendedDateRange ? 45 : 7;
      const conditionCheck =  this.selectedCategory.length === 0 || this.selectedCategory.length > 1 || this.selectedCloumn === 'all_courier_successfull' ||
      this.selectedCloumn === '' || differenceInDays > maxExportDays
      return conditionCheck
    },
  },
  methods: {
    async loadCounts() {
      let dateObj = null;
      const dates = this.dateRange && this.dateRange.map(date => date.toISOString());
      const selectedTransporterIds = this.selectedTransporterIds.filter(transporterId => transporterId !== 0);
      if (this.transporterList && this.transporterList.length) {
        const allTransporterSelected = this.transporterList.list.every(function(transporter) {
            return selectedTransporterIds.indexOf(transporter.id) !== -1;
        });
        if (allTransporterSelected){
          this.selectedTransporterIds = [];
        } else {
          this.selectedTransporterIds = selectedTransporterIds;
        }
      }
      if (dates && dates.length === 2) {
        dateObj = {
          start_date: dates[0],
          end_date: dates[1],
          event_type: this.integrationEvent ? interfaceEventType.INTEGRATION : interfaceEventType.COURIER,
          depotIds: this.selectedDepotIds,
          transporterIds: this.selectedTransporterIds.filter(ev => ev !== 0),
        };
      }
      if (this.integrationEvent) {
        this.integrationEventCount = await this.$store.dispatch('order/getIntegrationCounts', dateObj);
      } else if (this.isCourierEvent) {
        this.courierEventCount = await this.$store.dispatch('order/getIntegrationCounts', dateObj);
      } else {
        this.countData = await this.$store.dispatch('order/getExceptionCounts', dateObj);
      }
      this.setEmit();
    },
    setStartDate(minDate) {
      this.startDate = minDate;
    },
    sectionChange(item) {
      if (this.isLisLoadingCompleted) {
        this.selectedType = item.key;
        this.selectedCategory = (this.integrationEvent || this.isCourierEvent) ? [item.key] : [];
        this.selectedCloumn = item.columnMap;
        this.setEmit();
      }
    },
    async courierexport(){
     let courierdateObj;
     let result;
     const dates = this.dateRange && this.dateRange.map(date => date.toISOString());
      if (dates && dates.length === 2) {
        courierdateObj = {
          start_date: dates[0],
          end_date: dates[1],
          type: mdm.mdmType.courier_intergration_logs,
          courier_type: this.selectedCategory[0]
        };
         result = await this.$store.dispatch('order/getCourierIntegrationLogs', courierdateObj);
      }
      if (result.error){
        this.$error({ message: 'unable to process request' });
      }
      if(result && !result.error){
        this.$successMessage({ message: 'report will be sent to email' });
      }
    },
   async categoryChange(item) {
      this.selectedType = this.isCourierEvent ? interfaceEventType.COURIER : (interfaceEventType.INTEGRATION || EXCEPTION_TYPE.INDENTS);
      this.selectedCloumn = item.columnMap;
      if (this.selectedCategory.includes(item.key)) {
        this.selectedCategory = this.selectedCategory.filter(val => val !== item.key);
      } else if ((this.integrationEvent || this.isCourierEvent) && this.selectedCategory.includes(INTEGRATION_TYPE.SUCCESSFUL)) {
        this.selectedCategory = [];
        this.selectedCategory.push(item.key);
      } else {
        this.selectedCategory.push(item.key);
      }
      this.setEmit();
    },
    checkAndClear() {
      this.startDate = null;
    },
    checkAndUpdate() {
      // Adding this check to make sure. Clearing the date defaults to past 6 days and tomorrow.
      if (!this.dateRange) {
        this.dateRange = [];
        if (this.extendedDateRange) {
          this.dateRange[0] = moment(new Date()).subtract(44, 'days').startOf('day').toDate();
          this.dateRange[1] = moment(new Date()).endOf('day').toDate();
        } else {
          this.dateRange[0] = moment(new Date()).subtract(5, 'days').startOf('day').toDate();
          this.dateRange[1] = moment(new Date()).add(1, 'days').endOf('day').toDate();
        }
      }
      this.setEmit();
      this.loadCounts(this.dateRange);
    },
    toggleDatePicker() {
      this.dropDownActive = !this.dropDownActive;
    },
    dateClickOutside() {
      this.dropDownActive = false;
    },
    datesChange(index) {
      if (this.selectedDates.includes(index)) {
        this.selectedDates = this.selectedDates.filter(date => date !== index);
      } else {
        this.selectedDates.push(index);
      }
      this.setEmit();
      this.loadCounts(this.dateRange);
    },
    setEmit() {
      this.$emit('filter-change', {
        type: Number(this.selectedType),
        category: this.selectedCategory,
        dates: this.dateRange.map(date => date.toISOString()),
        columnMap: this.selectedCloumn,
        depotIds: this.selectedDepotIds,
        transporterId: this.selectedTransporterIds,
      });
    },
    async selectDepot(item){
      const findIndex = this.depotListData.selected.findIndex(depot=> depot.id == item.id);
      if(findIndex === -1){
        this.depotListData.selected = item;
      } else{
        this.depotListData.selected.unshift(findIndex);
        this.depotListData.selected.unshift(0);
      }
      if(this.depotListData.selected.length==0){
        this.depotListData.selected = [this.depotListData.list[0]];
      }
      const depot_id = this.depotListData.selected.filter(depot=> depot.id != 0).map(depot=> depot.id);
      this.selectedDepotIds = depot_id;
      this.selectedCategory = [this.successfulCourierItems[0].key];
      await this.loadCounts();
    },
    async selectTransporter(item){
      const findIndex = this.transporterList.selected.findIndex(transporter=> transporter.id === item.id);
      if(findIndex === -1){
        this.transporterList.selected = item;
      } else{
        this.transporterList.selected.unshift(findIndex);
        this.transporterList.selected.unshift(0);
      }
      if(this.transporterList.selected.length===0){
        this.transporterList.selected = [this.transporterList.list[0]];
      }
      const transporterIds = this.transporterList.selected.map(transporter=> transporter.id);
      this.selectedTransporterIds = transporterIds;
      this.selectedCategory = [this.successfulCourierItems[0].key];
      await this.loadCounts();
    }
  }
};
</script>
<style lang="scss">
.header-panel {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  justify-items: start;
  padding: 10px;

.multiselect__tags{
  background: none !important;
}
.multiselect__single{
  background:transparent !important;
  font-size: 14px;
}

.multiselect--active{
  background-color: #ffffff;
}
.dropdownaction_icon {
    .cancelblock{
      &:before{
        content: "";
        position: absolute;
        display: block;
        background: url('../asset/svg/arrow-down.svg') no-repeat;
        top: 8px;
        width: 14px;
        height: 14px;
      }
      svg{
        display: none;
      }
    }
}

}
</style>
